import React, { useEffect, useState } from 'react';
import { cn } from '@/utils/cn';
import TextSmall from '../Typography/TextSmall';

function StoreLocatorTimeDetails({ isOpenMenu, item }) {
  const [timeArray, setTimeArray] = useState([]);

  useEffect(() => {
    if (Object.keys(item)?.length > 0) {
      const hoursArray = Object.keys(item)
        .filter((key) => key.includes('_hours'))
        .map((key) => ({ key: key.replace('_hours', ''), value: item[key] }));

      setTimeArray([...hoursArray]);
    }
  }, [item]);

  return (
    <div
      className={cn(
        'store-locator-time-details bg-white max-h-0 lg:max-h-full my-4 ml-12 transition-all duration-300 hidden pr-16',
        { '!max-h-[500px] !block w-full max-w-auto': isOpenMenu },
      )}
    >
      {timeArray?.map((time, _) => (
        <div key={time.key} className="w-full flex justify-between">
          <TextSmall
            text={`${time.key.charAt(0).toUpperCase() + time.key.slice(1).toLowerCase()}:`}
            className="text-senate font-medium"
          />

          <TextSmall
            text={time.value}
            className="text-coarse-wool font-medium"
          />
        </div>
      ))}
    </div>
  );
}

export default StoreLocatorTimeDetails;
